module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_VIMEO-rechts_black-1d31c2e2eca39d372b1f352d877ad2e4.svg";